import React from 'react';
import classNames from 'classnames';

import {Props} from './types';
import {Layouts} from '@components';

import './index.scss';

const Thank: React.FC<Props> = props => {
  const isAuthed = !!props.me.id;
  return (
    <div className={classNames('a__thank-safe', {after: isAuthed})}>
      {!isAuthed && (
        <div className="b__header">
          <Layouts.Header.Before
            location={props.location}
            history={props.history}
          />
        </div>
      )}
      <div className="w__message">
        <div className="b__message-main">
          <div className="b__title">安否状況を送信しました</div>
          <div className="b__message">
            入力された内容を送信しました。
            <br />
            特権管理者または管理者の方は、PC版からログインして安否状況を確認してください。
            <br />
            既にログイン済みの方は、ダッシュボードから最新の安否状況を確認できます。
          </div>
        </div>
      </div>

      {!isAuthed && <Layouts.Footer.Main />}
    </div>
  );
};
export default Thank;
